// import AsyncStorage from '@react-native-async-storage/async-storage';
import config from "../config";

let userLang = null;

// Keys written by app code (not the auth token itself) that are scoped to a
// single user session. They must be explicitly cleared on logout: unlike
// before, they can now live in localStorage (see getActiveStorage below),
// which survives logout unless cleared, unlike sessionStorage's tab-close
// semantics — so a shared device could otherwise leak one user's cached
// values into the next login.
const APP_STATE_KEYS = [
  config.USER_ID,
  config.TIMEZONE,
  config.LANG,
  config.USERNAME,
  config.HAS_KIPPU_ACC_ID,
  config.VERIFICATION_STATUS,
  config.JUST_UNSUBSCRIBED,
  config.SMS_CLICKED_YES,
];

// The auth token lives in localStorage when "stay logged in" is checked
// (persists across new tabs/browser restarts) or sessionStorage otherwise
// (cleared with the tab). App-state values written via this service must
// live exactly as long as the token does, or they go stale/disappear in a
// fresh tab while the user is still authenticated there — the bug behind
// the HasKippuAccId incident. Reads/writes only ever target this one
// storage — no cross-storage fallback — since falling back to "whichever
// storage has anything" would let a previous user's leftover data on a
// shared device leak into a new login instead of being treated as absent.
const getActiveStorage = () =>
  localStorage.getItem(config.TOKEN) != null ? localStorage : sessionStorage;

export default {
  getStorageItem: (key) => {
    try {
      const value = getActiveStorage().getItem(key);
      return value !== null && value !== "null" ? value : null;
    } catch (error) {
      return null;
    }
  },
  setStorageItem: (key, value) => {
    try {
      getActiveStorage().setItem(key, value.toString());
    } catch (error) {}
  },

  // Removes every app-state key from BOTH storages regardless of which one
  // is currently active. Must run on logout so nothing can leak into a
  // different user's session on a shared device/browser.
  clearAppState: () => {
    APP_STATE_KEYS.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {}
      try {
        sessionStorage.removeItem(key);
      } catch (error) {}
    });
  },

  removeStorageItem: async (key, value) => {
    try {
      await sessionStorage.setItem(key, value.toString());
    } catch (error) {}
  },

  getUserLocale: function () {
    //return "fr-CA";
    if (userLang == null) {
      return "en-CA";
    } else {
      return userLang;
    }
  },
  setUserLocale: function (language) {
    userLang = language;
  },
};
